import styled from "styled-components"

const Label = styled.span`
  color: ${props => props.color || "#000"};
  font-family: lato, sans-serif;
  font-weight: 700;
`

export default Label
